export default __webpack_public_path__ + "fonts/Nunito-Medium.06740446.ttf";